import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvatar = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31 17.25C29.7611 12.5013 25.3873 8.9914 20.1729 9.00002C14.2554 9.00918 9.2419 13.7483 9.00893 19.56C8.75732 25.8392 13.8547 31 20.1822 31C25.0501 31 29.1823 27.9374 30.7147 23.6667",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.659 28.9375C13.7801 25.5 16.6503 22.75 20.1822 22.75C23.332 22.75 25.9692 24.95 26.5749 27.8742C26.6495 28.2133 26.6867 28.5708 26.7054 28.9283",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1822 20C21.7262 20 22.9778 18.7688 22.9778 17.25C22.9778 15.7312 21.7262 14.5 20.1822 14.5C18.6382 14.5 17.3865 15.7312 17.3865 17.25C17.3865 18.7688 18.6382 20 20.1822 20Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgAvatar);
export default ForwardRef;
